module.exports = __webpack_public_path__ + "static/assets/41aa90c906e353e66d749eaacf455dee.png";